import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Constanst } from 'src/app/core/constants/constans.component';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/shared/models/user';
import { FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DetalleUsuarioComponent } from '../detalle-usuario/detalle-usuario.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-lista-usuarios',
  templateUrl: './lista-usuarios.component.html',
  styleUrls: ['./lista-usuarios.component.css'],
  providers: [DatePipe]
})
export class ListaUsuariosComponent implements OnInit {
  displayedColumns: string[] = ['username', 'fullName', 'license', 'isExpired', 'initDateLicense', 'endDateLicense', 'rifCompany', 'companyName'];

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  dataSourceFilters = new MatTableDataSource<User>;
  filterValue: string;
  filterDetails = new FormControl('0');
  filterNoSelected: boolean = false;
  filterDictionary = new Map<string | null, string | null>();
  descriptionSearch = new FormControl({ value: '', disabled: false });
  messageError: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public apiCallService: ApiCallService,
    public dialogDetalleUsuario: MatDialog,
    private helperClassService: HelperClassService,
    private router: Router) { }

  ngOnInit(): void {
    this.getAllUsers();
    this.dataSourceFilters.filterPredicate = function (record, filter) {
      var map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (let [key, value] of map) {
        if (key as keyof User === 'username') {
          isMatch = (record.username || '').trim().toLowerCase().indexOf(value as keyof User) !== -1;
        } else if (key as keyof User === 'fullName') {
          isMatch = (record.fullName || '').trim().toLowerCase().indexOf(value as keyof User) !== -1;
        } else if (key as keyof User === 'rifCompany') {
          isMatch = (record.rifCompany || '').trim().toLowerCase().indexOf(value as keyof User) !== -1;
        } else if (key === "0") {
          isMatch = (record.username || '').trim().toLowerCase().indexOf(value as keyof User) !== -1
            || (record.fullName || '').trim().toLowerCase().indexOf(value as keyof User) !== -1
            || (record.license || '').trim().toLowerCase().indexOf(value as keyof User) !== -1
            || (record.rifCompany || '').trim().toLowerCase().indexOf(value as keyof User) !== -1
            || (record.companyName || '').trim().toLowerCase().indexOf(value as keyof User) !== -1

        } else if (value === '') {
          isMatch = true;
        };
        if (!isMatch) return false;
      }
      return isMatch;
    };
    this.helperClassService.notifierUpdatedUser.subscribe(data => {
      //console.log('Recibiendo notificacion usuario actualizado: ' + data);
      this.getAllUsers();
    });
  }

  applyFilterDetails(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    /*     if (this.filterDetails.value === '0' && this.filterValue === '') {
          this.filterNoSelected = true;
        } else {
          this.filterNoSelected = false;
        } */

    this.filterDictionary.set(this.filterDetails.value, this.filterValue);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.dataSourceFilters.filter = jsonString;

    if (this.dataSourceFilters.paginator) {
      this.dataSourceFilters.paginator.firstPage();
    }
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.dataSourceFilters.sort = this.sort;
  }

  getAllUsers() {
    this.route = '/getUserList';
    this.method = 'POST';

    this.apiCallService.call$(null, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          //console.log(response);
          let userList = response;
          let numLicencias = 0;
          var userListOutput: User[] = [];
          var count = 0;
          var start = false;
          let licenseActive = 0;
          var licenseArray = [];
          let licenseFrom;
          let licenseTo;

          for (let j = 0; j < userList.length; j++) {
            //Inicio validar y contar licencias de un usuario
            numLicencias = 0; licenseActive = 0;
            let name = userList[j].username;
            for (let u = 0; u < userList.length; u++) {
              let data = userList[u];
              if (data.username == name) {
                numLicencias++;
                licenseArray.push(data.isExpired);
                //Si la licencia esta activa, se toma fecha activa.
                if (!data.isExpired) {
                  licenseFrom = data.initDateLicense;
                  licenseTo = data.endDateLicense;
                }
              }
            }
            //Verificar si tiene licencia activa.
            for (let l = 0; l < licenseArray.length; l++) {
              if (!licenseArray[l]) {
                licenseActive++;
                break;
              }
            }
            licenseArray = [];
            //Fin validar y contar licencias de un usuario
            //Inicio validar y juntar un usuario con todas sus licencias
            for (let k = 0; k < userListOutput.length; k++) {
              if (name == userListOutput[k].username) {
                start = true;
              }
            }
            count++;
            if (count == 1 && start == false) {
              userList[j].license = numLicencias.toString();
              userList[j].isExpired = (licenseActive == 1 ? false : true);
              //Si la licencia esta activa, se muestra fecha activa.
              //De lo contrario, se deja la fecha vencida por default.
              if (!userList[j].isExpired) {
                userList[j].initDateLicense = licenseFrom;
                userList[j].endDateLicense = licenseTo;
              }
              userListOutput.push(userList[j]);
            }
            start = false;
            count = 0;
          }
          //Fin validar y juntar un usuario con todas sus licencias

          this.dataSourceFilters.data = userListOutput;
          this.apiCallService.hideSpinner();
        }
      );
  }

  verDetalle(row: User) {
    const dialog = this.dialogDetalleUsuario.open(DetalleUsuarioComponent, {
      width: '60rem',
      data: { row }
    });
  }

}
